import HideIfPrint from './HideIfPrint';
export default HideIfPrint;



// WEBPACK FOOTER //
// ./src/components/HideIfPrint/index.js